export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5af0d40e16a15daea798c93d451dc485.jpg"
          alt="BritFit mobile tyre service van"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-32">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 border border-white/40 text-white text-xs font-medium px-4 py-1.5 rounded-full mb-8 backdrop-blur-sm bg-white/10">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            Available 24/7 Across the UK
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>
            <span className="text-[#6EE7B7]">BritFit</span><br />
            Mobile Tyres
          </h1>

          <p className="text-base md:text-lg text-stone-300 leading-relaxed mb-10 max-w-xl">
            Fast, reliable tyre services across the UK — we come to you at home, work, or roadside. No waiting, no hassle.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo('contact')}
              className="flex items-center justify-center gap-3 bg-[#1B4332] hover:bg-[#145228] text-white font-semibold px-8 py-4 rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
            >
              <span className="w-5 h-5 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-calendar-check-line text-xs" />
              </span>
              Book a Fitting
              <i className="ri-arrow-right-line text-sm" />
            </button>
            <button
              onClick={() => scrollTo('services')}
              className="flex items-center justify-center gap-2 border border-white/50 hover:border-white text-white font-semibold px-8 py-4 rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200 backdrop-blur-sm"
            >
              View Services
            </button>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 md:mt-24 flex flex-wrap gap-8 md:gap-16">
          {[
            { val: '12+', label: 'Years in Service' },
            { val: '28K+', label: 'Tyres Fitted' },
            { val: '4.9★', label: 'Customer Rating' },
            { val: '60min', label: 'Avg. Response' },
          ].map((s) => (
            <div key={s.label}>
              <div className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: 'Syne, sans-serif' }}>
                {s.val}
              </div>
              <div className="text-stone-400 text-xs mt-0.5">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-lg" />
      </div>
    </section>
  );
}
